export default {
  EXIBIR_COMO_BAIXAR: true,
  EXIBIR_COMO_ENVIAR: true,
  EXIBIR_CADASTRO_ONLINE: true,
  EXIBIR_ACESSAR_ONLINE: true,
  EXIBIR_CONSULTA: {
    LEGISLACAO: false,
    AUTENTICIDADE: true,
    MAPA: false,
    PROCESSO: true,
    FALE_CONOSCO: false,
    SEJA_UM_CREDENCIDADO: false,
    ACERVO_FUNDIARIO: false,
    PORTARIA_HOMOLOGACAO: false,
    HEADER: true
  },
  EXIBIR_OBSERVACAO_CONSULTA_PROCESSOS: false,
  MAIN: {
    TITULO: 'SICARF-MA - Tecnologia para regularização fundiária das terras do Estado do Maranhão',
    EXIBIR_IMPORTANTE: false,
    BACK_GROUND: "background-image: url('static/sicarfPrincipal-ma.jpg')"
  },
  MANUAL_USUARIO: {
    DESCRICAO: 'Utilize estes manuais como um guia de utilização do SiCARF Off-line e Online, eles contêm as informações sobre como realizar os cadastros e importá-los para o Módulo de Análise, para ser possível iniciar o processo de regularização de sua terra.',
    MANUAL_ON: false,
    MANUAL_OFF: true,
    EXIBIR: true
  },
  HOME_PAGE: {
    ENTRE_EM_CONTATO: {
      SOBRE: 'O Instituto de Colonizações e Terras do Estado do Maranhão - ITERMA é um órgão público estadual que tem por objetivos promover a regularização fundiária, entendida como instrumento primeiro para ordenar o espaço e democratizar o acesso à terra.',
      ENDERECO: 'Endereço: Rua H, 24, Quadra J - Bairro: Jardim Eldorado/Turu, São Luís - MA - CEP: 35075-740',
      TELEFONE: 'Telefone: (98) 8409-9152',
      SUPORTE: 'Suporte técnico: suportesicarf.iterma@gmail.com',
      SITE: 'Site: www.iterma.ma.gov.br',
      HORARIO_FUNCIONAMENTO: 'Segunda à Sexta-feira, de 13:00 às 19:00 horas.',
      EXIBIR_FORMULARIO: true
    },

    CADASTROS_ONLINE: [
      {
        TOLLTIP: 'Para aqueles que querem confirmar se um título de terras foi expedido ou se a área é pública estadual (jurisdição).',
        SPAN: 'Solicitar <b>informação de autenticidade de títulos</b> e de <b>jurisdição de áreas</b>'
      },
      {
        TOLLTIP: 'Para aqueles que pretendem fazer o procedimento de permuta.',
        SPAN: 'Solicitar <b>permuta</b>'
      }
    ],

    CADASTROS_OFFLINE: [
      {
        TOLLTIP: 'Rugularização fundiária para pessoa física que exerce agricultura familiar.',
        SPAN: 'Solicitar a <b>Regularização por Doação</b>',
        TEXTO: '(Não onerosa)',
        NEED_BREAK: false
      },
      {
        TOLLTIP: 'Regularização fundiária para pessoa física ou jurídica que exerce atividade agrária',
        SPAN: 'Solicitar a <b>Regularização por Compra</b>',
        TEXTO: '(Onerosa)',
        NEED_BREAK: false
      },
      {
        TOLLTIP: 'Regularização fundiária de áreas coletivas formadas por agricultores familiares que estão distribuídos no espaço em lotes.',
        SPAN: 'Solicitar a criação de <b>Projeto Estadual de Assentamento Sustentável</b>',
        TEXTO: '(PEAS)',
        NEED_BREAK: false
      },
      {
        TOLLTIP: 'Regularização fundiária de comunidades remanescentes de quilombolas.',
        SPAN: 'Solicitar a criação de <b>Território Estadual Quilombola</b>',
        TEXTO: '(TEQ)',
        NEED_BREAK: false
      }
    ],

    TITULO_CADASTRO: 'COMO FAZER O SEU CADASTRO',

    TITULO_CADASTRO_OFF: 'CADASTRO',
    SUBTITULO_CADASTRO_OFF: 'OFF-LINE',

    TITULO_CADASTRO_ON: 'CADASTRO',
    SUBTITULO_CADASTRO_ON: 'ON-LINE',

    TEXTO_CADASTRO: '<strong>Cadastro off-line:</strong> para solicitar os serviços no ITERMA ' +
      'descritos no banner ao lado <strong>Cadastro off-line.</strong> ' +
      'Para realizar os cadastros você deve primeiro instalar no seu computador o sistema.<br/> <br/>' +
      'Atenção! Basta instalar uma vez. <br/><br/>' +
      '<strong>Cadastro on-line:</strong> permite ao usuário solicitar ao ITERMA ' +
      'os serviços específicos identificados no banner <strong>Cadastro on-line.</strong> ' +
      'Para esses serviços, você não precisa baixar nenhum sistema. ' +
      'Basta clicar em "ACESSE" e ter em mãos os documentos necessários no formato digital.',

    O_SICARF_TITULO: 'O SiCARF',

    O_SICARF: 'É o sistema tecnológico do ITERMA voltado para cadastrar, ' +
      'informar e regularizar terras do Estado do Maranhão de acordo com a legislação. ' +
      'Por meio dele será ampliado o acesso, a eficiência e a trasparência nas solicitação de Regularização Fundiária e ' +
      'demais serviços públicos fundiários usando os benefícios que a ' +
      'tecnologia proporciona a quem precisa ter segurança jurídica. ' +
      'As vantagens do SiCARF são:' +
      '<br>',

    O_SICARF_DESCRICAO: '<b>1.</b> Processo 100% digital, ou seja, sem necessidade do Interessado se deslocar ' +
      'ao ITERMA para cadastrar, juntar documentos, ou consultar o processo; ' +
      '<br>' +
      '<b>2.</b> Módulo off-line para realizar cadastros mesmo sem acesso ' +
      'momentâneo à internet;' +
      '<br>' +
      '<b>3.</b> Notificação e troca de mensagens com o interessado através ' +
      'de ferramenta on-line;' +
      '<br>' +
      '<b>4.</b> Agilidade no andamento e tramitação dos processos;' +
      '<br>' +
      '<b>5.</b> Desburocratização e maior fluidez do processo de ' +
      'Regularização Fundiária e demais serviços do ITERMA;' +
      '<br>' +
      '<b>6.</b> Transparência de informações junto ao público externo e ' +
      'outros órgãos;',

    O_SICARF_DESCRICAO_IMG: 'static/sicarfReceptor.png',

    EXIBIR_COMENTARIOS: false,

    EXIBIR_GALERIA: false,

    COMO_FUNCIONA: {
      COMO_FUNCIONA_IMAGEM_1: 'static/quadrado-ma1.png',
      COMO_FUNCIONA_1: 'Munido das suas informações pessoais e da área faça o seu ' +
        'cadastro de regularização fundiária no SICARF-MA ou de outro serviço disponível nessa plataforma. ' +
        'Você não precisa comparecer ao ITERMA, basta preencher algumas informações sobre solicitante e ' +
        'área de interesse. É prático, rápido e intuitivo.',

      COMO_FUNCIONA_IMAGEM_2: 'static/quadrado2.png',
      COMO_FUNCIONA_2: 'Após o cadastramento, o seu processo será analisado pela equipe ' +
        'técnica do ITERMA. Toda a tramitação do processo ocorrerá de ' +
        'forma 100% digital.',

      COMO_FUNCIONA_IMAGEM_3: 'static/quadrado-ma3.png',
      COMO_FUNCIONA_3: 'Você poderá acompanhar o andamento do seu processo através da Central ' +
        'do Interessado, onde será possível receber as notificações e responder ' +
        'as solicitações relacionadas ao processo.'
    }
  },

  CENTRAL_DO_INTERESSADO: {
    DESCRICAO: 'é o módulo dentro do SICARF-MA que serve de comunicação entre o ITERMA e o solicitante do serviço do órgão fundiário estadual. Ele é composto por dois submódulos: a Central de Mensagens e o Cadastro On-line.',
    CADASTROS_ONLINE: {
      DESCRICAO: 'permite ao usuário realizar solicitações para serviços do ITERMA de informação sobre a expedição de títulos e de permuta.'
    }
  },
  FOOTER: {
    O_SICARF: 'O SiCARF',
    EXIBIR_REDES_SOCIAIS: true,
    ENDERECO: 'Rua H 24, Quadra J - Bairro: Jardim Eldorado/Turu -  São Luís - MA',
    CEP: 'CEP: 35075-740',
    LOGO: 'static/governo-ma.png',
    FACEBOOK: 'https://www.facebook.com/iterma.ma',
    YOUTUBE: 'https://www.youtube.com/channel/UCwEarV5kRf2YgEDYOdj0Ulw',
    TWITTER: 'https://twitter.com/itermama',
    INSTAGRAM: ' https://www.instagram.com/iterma_oficial/'
  },

  EXIBIR_OBSERVACOES: false,

  EXIBIR_MODELOS_DOCS: true,

  EXIBIR_DUVIDAS_FREQUENTES: true,

  EXIBIR_CREDENCIADOS: false,

  DOCUMENTOS_NECESSARIOS: {
    OBRIGATORIEDADE_SHAPE: true,

    EXIBIR_DOCUMENTO_QUITACAO: false,

    EXIBIR_CERTIDAO_NASCIMENTO: false,

    EXIBIR_DRL: true
  },

  SIMULAR_VTN: {
    DESCRICAO: '',
    EXIBIR: false
  }

}



// WEBPACK FOOTER //
// ./src/constants/ma/dadosEstado/portal/publico.js